import SiteHeader from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { galleryImages, galleryCategories } from "../data/siteContent";
import { useState } from "react";

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredImages = activeCategory === "All" 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  return (
    <>
      <SEO 
        title="Gallery"
        description="Explore our photo gallery showcasing the beautiful landscapes, authentic experiences, and rustic accommodations at Gawkari Hillside."
      />
      <SiteHeader />
      <main>
        <section className="py-5">
          <div className="container">
            <div className="text-center mb-5">
              <span className="badge bg-green-lt mb-2">Our Gallery</span>
              <h1 className="display-5 fw-bold text-dark">Moments from Gawkari Hillside</h1>
              <p className="text-secondary mx-auto mt-3" style={{ maxWidth: '640px' }}>
                Browse through our collection of authentic moments captured at the retreat
              </p>
            </div>

            <div className="d-flex justify-content-center flex-wrap gap-2 mb-5">
              <button
                className={`btn ${activeCategory === "All" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setActiveCategory("All")}
              >
                All
              </button>
              {galleryCategories.map((category) => (
                <button
                  key={category.name}
                  className={`btn ${activeCategory === category.name ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveCategory(category.name)}
                >
                  {category.name}
                </button>
              ))}
            </div>

            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
              {filteredImages.map((image, index) => (
                <div key={index} className="col">
                  <div className="position-relative overflow-hidden rounded shadow-sm ratio ratio-4x3">
                    <img src={image.src} alt={image.alt} loading="lazy" className="w-100 h-100 object-fit-cover" />
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-end p-3 text-white" style={{background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)'}}>
                      <span className="badge bg-primary mb-1 align-self-start">{image.category}</span>
                      {image.location && <span className="small d-flex align-items-center"><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-map-pin me-1" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" /></svg>{image.location}</span>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
